import Blink from '@components/Blink'
import ControlledCheckbox from '@components/ControlledCheckbox'
import useLeserreporterContext from '@hooks/useLeserreporterContext'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import ErrorMessage from './ErrorMessage'

const Wrapper = styled.div`
  ${({
    theme: {
      colors: { strokeWeak },
      spacing: { spacing28 },
    },
  }) => css`
    border-top: 1px solid ${strokeWeak};
    padding: ${spacing28} 0;
  `}
`

const StyledLesereporterBlink = styled(Blink)`
  ${({
    theme: {
      colors: { textDefault, textBrand },
    },
  }) => css`
    color: ${textDefault};

    &:hover {
      color: ${textBrand};
    }
  `}
`

const ConsentCheckbox: FunctionComponent = () => {
  const {
    consent: consentValue,
    handleChangeConsent,
    validation: { consent: validation },
  } = useLeserreporterContext()
  const passedValidation = validation === true
  return (
    <Wrapper>
      <ControlledCheckbox
        name="consent"
        checked={consentValue}
        onChange={handleChangeConsent}>
        Ich habe die{' '}
        <StyledLesereporterBlink href="#">
          Leserreporter-AGB gelesen
        </StyledLesereporterBlink>{' '}
        und bin einverstanden
      </ControlledCheckbox>
      {!passedValidation && validation && (
        <ErrorMessage>{validation as string}</ErrorMessage>
      )}
    </Wrapper>
  )
}

export default ConsentCheckbox
